export const environment = {
  maintenanceMode: true,
  production: false,
  urlApi: "https://hml-api-hub-bmgseguros.azurewebsites.net/api",
  cookieDomain: "azurewebsites.net",
  urlFront: "https://hml-app-hub-bmgseguros.azurewebsites.net",
  urlWorkflow: "https://hml-app-hubexternal-bmgseguros.azurewebsites.net",
  G_ANALYTICS_APP: "G-D594GMEF88",
  clarity: {
    applicationId: "jci2ayl2y5",
  },
  applicationInsights:{
    enable: true,
    connectionString: "InstrumentationKey=bb5e5fe9-ef73-44c9-99a3-9a57162a50a3;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=355a409b-892d-467c-af67-def2c028f909"
  }
};